import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <div className="fixed bottom-6 right-6 z-50 group" data-id="element-310">
      <a href="https://wa.me/56992180727" target="_blank" rel="noopener noreferrer" className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20bd5a] transition-colors hover:scale-105 active:scale-95 transition-transform" aria-label="Hablar por WhatsApp" data-id="element-311">
        <MessageCircle className="w-7 h-7 fill-current" data-id="element-312" />
      </a>

      {/* Tooltip */}
      <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-gray-900 text-white text-sm font-medium rounded-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-313">
        Hablar por WhatsApp
        <div className="absolute top-1/2 -right-1 -translate-y-1/2 border-4 border-transparent border-l-gray-900" data-id="element-314"></div>
      </div>
    </div>;
}